import { FetchResult } from "@apollo/client";

export function graphqlExtractInternalErrors(
  response: FetchResult<any, Record<string, any>, Record<string, any>>
): Array<string> | null {
  const errorArray: Array<string> = [];

  if (Array.isArray(response.errors)) {
    response.errors.forEach((error) => {
      if (error.extensions?.category === "internal") {
        errorArray.push(error.debugMessage);
      }
    });
  }

  if (errorArray.length) return errorArray;

  return null;
}
